import { render, staticRenderFns } from "./GestorLayout.vue?vue&type=template&id=064cc92c&scoped=true"
import script from "./GestorLayout.vue?vue&type=script&lang=js"
export * from "./GestorLayout.vue?vue&type=script&lang=js"
import style0 from "./GestorLayout.vue?vue&type=style&index=0&id=064cc92c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "064cc92c",
  null
  
)

export default component.exports